import styled from 'styled-components';
import { commonInputStyle, InputStyleProps } from '@ardoq/forms';
import { colors, r4, s8 } from '@ardoq/design-tokens';
import { DropdownActionStyle } from '@ardoq/dropdown-menu-ui';

// Styled like an Ardoq text input, but is a button.
export const InputButton = styled.button<
  InputStyleProps & { $hasPrefix?: boolean; $isDisabled?: boolean }
>`
  display: flex;
  align-items: center;
  background-color: ${({ $isDisabled }) =>
    $isDisabled ? colors.surfaceDisabled : colors.surfaceDefault};
  color: ${({ $isDisabled }) =>
    $isDisabled ? colors.textDisabled : colors.textDefault};
  position: relative;
  ${commonInputStyle};
  padding-right: 8px;
  text-align: ${({ $alignText }) => $alignText};
  border-radius: ${({ $hasPrefix, $hasPostfix }) =>
    `${$hasPrefix ? 0 : r4} ${$hasPostfix ? 0 : r4} ${$hasPostfix ? 0 : r4} ${
      $hasPrefix ? 0 : r4
    }`};
`;

export const DisplayValueOrPlaceholder = styled.span<{
  $isOpen: boolean;
  $isPlaceholder?: boolean;
}>`
  flex: 1;
  color: ${({ $isPlaceholder }) =>
    $isPlaceholder ? colors.textSubtle : colors.textDefault};
  opacity: ${({ $isOpen }) => ($isOpen ? 0 : 1)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClearIndicatorStyle = styled(DropdownActionStyle)<{
  $isVisible?: boolean;
}>`
  opacity: ${({ $isVisible = true }) => ($isVisible ? 1 : 0)};
  margin-right: ${s8};
`;
